import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export function getCurrentDayAndMonth(date: string) {
	let sanitizedMonth = "";
	dayjs.extend(utc);
	const dayjsUtc = dayjs.utc(date);
	const localDate = dayjsUtc.local().format();
	const day = dayjs(localDate).date();
	// month is from 0 to 11
	const month = dayjs(localDate).month() + 1;
	if (month < 10) {
		sanitizedMonth = "0" + String(month);
	} else {
		sanitizedMonth = String(month);
	}
	return `${day}/${sanitizedMonth}`;
}
